import moment from "moment";

export const formatDateTime = (date) => {
    if (!date) {
        return "";
    }
    return moment(date).format("DD/MM/YYYY H:mm:ss")
}

export const formatDateTimeDMY = (date) => {
    if (!date) {
        return "";
    }
    return moment(date).format("DD/MM/YYYY")
}